import React, { useEffect, useState } from 'react'
import moment from 'moment'

// components
import {
  CCol,
  CFormLabel,
  CFormText,
  CRow
} from '@coreui/react-pro'
import AppTextColumnDetails from '../general-details/AppTextColumnDetails'
import { getFullName } from 'src/helpers/text-format'

// helpers
import Axios from 'src/helpers/axios'

const AppFirstDetails = ({
  customerDetails,
  customerBookingHistory,
}) => {

  return (
    <>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Customer ID"
          subtitle={customerDetails?.user_uuid || '-'}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="First Name"
          subtitle={
            customerDetails?.profile?.first_name ?
              customerDetails?.profile?.first_name
              : customerBookingHistory && customerBookingHistory?.length > 0 ?
                customerBookingHistory[0]?.first_name
                : "-"
          }
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Last Name"
          subtitle={
            customerDetails?.profile?.last_name ?
              customerDetails?.profile?.last_name
              : customerBookingHistory && customerBookingHistory?.length > 0 ?
                customerBookingHistory[0]?.last_name
                : "-"
          }
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Date of Birth"
          subtitle={
            customerDetails?.profile?.date_of_birth ?
              moment(customerDetails?.profile?.date_of_birth).format('l')
              : customerBookingHistory && customerBookingHistory?.length > 0 ?
                moment(customerBookingHistory[0]?.date_of_birth).format('l')
                : "-"
          }
        />
      </CRow>
      <CRow>
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Email Address"
          subtitle={customerDetails?.email}
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Phone Number"
          subtitle={
            customerDetails?.profile?.phone_number ?
              customerDetails?.profile?.phone_number
              : customerBookingHistory && customerBookingHistory?.length > 0 ?
                customerBookingHistory[0]?.phone_number
                : "-"
          }
        />
        <AppTextColumnDetails
          colSize="3"
          className="mb-3"
          title="Registered On"
          subtitle={moment(customerDetails?.createdAt).format('DD/MM/YYYY HH:mm')}
        />
      </CRow>
    </>
  )
}

export default AppFirstDetails
